"use client";

import React, { useState, useEffect } from "react";
import NoInternetPage from "./index";

export default function InternetConnectionHandler({ children }) {
  const [isOffline, setIsOffline] = useState(false);
  const [isChecking, setIsChecking] = useState(false);

  const checkConnection = async () => {
    if (typeof window === "undefined") return;
    setIsChecking(true);

    if (!window.navigator.onLine) {
      setIsChecking(false);
      alert("You are still offline. Please check your internet connection.");
      return;
    }

    try {
      // Perform a HEAD request to a local asset with no-store cache to verify real network connection
      const response = await fetch("/favicon.ico", {
        method: "HEAD",
        cache: "no-store",
      });
      
      if (response.ok) {
        setIsOffline(false);
        window.location.reload();
      } else {
        alert("You are still offline. Please check your internet connection.");
      }
    } catch (error) {
      alert("You are still offline. Please check your internet connection.");
    } finally {
      setIsChecking(false);
    }
  };

  useEffect(() => {
    if (typeof window === "undefined") return;

    // Initialize connection status
    setIsOffline(!window.navigator.onLine);

    const handleOnline = () => {
      checkConnection();
    };

    const handleOffline = () => {
      setIsOffline(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Global fetch interceptor to catch offline API call failures
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      try {
        const response = await originalFetch(...args);
        return response;
      } catch (error) {
        if (!window.navigator.onLine) {
          setIsOffline(true);
        }
        throw error;
      }
    };

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      window.fetch = originalFetch;
    };
  }, []);

  if (isOffline) {
    return (
      <NoInternetPage 
        onRetry={checkConnection} 
        isChecking={isChecking}
      />
    );
  }

  return children;
}
